export default {"src":"/_next/static/media/photopia-logo.740e267d.svg","height":203,"width":770};